'use strict';

module.exports = function sortObjectKeys(obj) {
    return Object.keys(obj).sort();
};
